export enum BrandFeatures {
	Uncategorized = 'Uncategorized',
	UncategorizedIncome = 'UncategorizedIncome',
}
